import { render, staticRenderFns } from "./add1.vue?vue&type=template&id=2cbad56f&scoped=true"
import script from "./add1.vue?vue&type=script&lang=js"
export * from "./add1.vue?vue&type=script&lang=js"
import style0 from "./add1.vue?vue&type=style&index=0&id=2cbad56f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbad56f",
  null
  
)

export default component.exports